<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFileDocumentOutline } from "@mdi/js";
export default {
  name: "MdiFileDocumentOutline",
  data() {
    return {
      svgPath: mdiFileDocumentOutline,
    };
  },
};
</script>
